<div class=" documentsContractTable" *ngIf="data">
  <div
      class="card-panel border-secondary"
      style="box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.2); height: 323px;"
  >
      <!--h3 class="card-header section-title" style="font-size: 1.6rem">
          {{ data.header }}
      </!--h3-->

      <div class="p-3">
        <!--app-section-title ng-reflect-section-title-config="[object Object]"-->
          <div class="table-title d-flex flex-column flex-md-row align-items-center">
            <div class=""><!--div class="ml-lg-3"-->
              <img height="70px" width="60px" class="magnifying-glass-title__icon"
                    src="assets/images/signedContract.png" alt="papyrus icon for table title">
            </div>
            <div style="padding-top: 10px; padding-left: 10px;">
              <h3 class="d-inline-block align-self-center ml-lg-1 section-title" style="font-size: 1.6rem;">
                Συμβόλαιο
              </h3>
            </div>
          </div>
        <!--app-section-title-->
      </div>

      <div class="card-body p-3">
          <div class="row card-subtitle pl-3 pr-3 mt-1 align-bottom">
              <h5
                  class="card-subtitle mb-2 text-muted"
                  style="font-size: 1rem"
              >
                <div class="fieldgroup">
                  <div class="row">
                    <div class="col-md-5" style="padding-top: 10px;">
                    {{ data.id.label }}
                    </div>
                    <div class="col-md-7">
                      <input type='text' class="form-control" value="{{data.id.value}}" name="documentId"
                      id="documentIdInput" placeholder="{{data.id.placeholder}}"
                      (input)="validateInput($event)"
                      (blur)="onBlurMethod($event, data.id.value)">
                      <span class="error hidden">{{data.id.error}}</span>
                    </div>
                  </div>
                </div>
              </h5>
          </div>
          <div class="row card-subtitle pl-3 mt-1 pr-3">
            <h4 class="card-subtitle mb-2 text-muted" style="font-size: 1rem">

              <!--
              <div class="fieldgroup">
                <div class="row">
                  <mat-form-field [style.width.px]=200>
                    <mat-label>{{
                        data.id.label
                    }}</mat-label>
                    <input
                    matInput
                    type="text"
                    id="{{ data.id.type }}"
                    class=""
                    value="{{ data.id.value }}"
                    name="{{ data.id.label }}"
                    placeholder="{{ data.id.placeholder }}"
                />
                  </mat-form-field>

                  <span class="error hidden">
                    {{ data.id.error }}
                  </span>
                </div>

                <div class="row">
                  <mat-form-field [style.width.px]=200>
                    <mat-label>Choose a date</mat-label>
                    <input matInput [matDatepicker]="picker">
                    <mat-hint>MM/DD/YYYY</mat-hint>
                    <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                  </mat-form-field>
                  <span class="error hidden">
                    {{ data.date.error }}
                  </span>
                </div>
              </div>
            -->

              <div class="fieldgroup">
                <div class="row">
                  <div class="col-md-5">
                    {{ data.date.label }}
                  </div>
                  <div class="col-md-7">
                    <div class="input-group calendar-group">
                      <input class="form-control" placeholder="yyyy-mm-dd" id="contract-date" name="dp"
                      [(ngModel)]="model" ngbDatepicker #d="ngbDatepicker" name="calendardate" readonly
                      (blur)="onBlurMethod($event, '')"/>
                      <span class="error hidden">{{data.date.error}}</span>
                      <button class="btn btn-outline-secondary bi bi-calendar3 p-0 m-0" (click)="d.toggle()" type="button">
                        <i class="material-icons align-middle p-0 m-0 calendar-icon">
                          table
                        </i>
                      </button>
                    </div>

                  </div>
                </div>
              </div>
            </h4>
          </div>
          <div class="row card-subtitle pl-1 mt-1 pr-1">
            <div class="row">
            <div class="col-md-6">
              <input id="documentCadastre" type="file" name="documentCadastre" (change)="handleFileChange($event, data.appid)" #inputFile hidden/>
              <button class="mt-2 btn btn-secondary app-button" (click)="uploadDocument()">
                <span style="font-size: medium">
                    {{ data.button }}</span
                >
              </button>
              <a class="file-holder" (click)="preview($event)"></a>
            </div>
            <div class="col-md-6">

              <button class="mt-2 btn btn-secondary app-button" (click)="documentAction(data.appid)">
                  <span style="font-size: medium">
                      Προβολή </span
                  >
              </button>
            </div>

          </div>
          <div *ngIf="data.button2" class="row">
            <div class="col-md-12">
                <button class="mt-1 btn btn-secondary app-button" (click)="clickHandler(data.button2Method, data.button2Arg)">
                    <span style="font-size: medium">
                        {{ data.button2 }}</span
                    >
                </button>
              <br>
            </div>
          </div>
        </div>
      </div>
  </div>
</div>

<!--
<div class="col-12 documentsContractTable" *ngIf="data">
  <div
      class="card-panel border border-secondary"
      style="background-color: rgb(255, 255, 255)"
  >
      <h3 class="card-header section-title" style="font-size: 1.6rem">
          {{ data.header }}
      </h3>
      <div class="card-body p-3">
          <div class="row card-subtitle pl-3 mt-1 pr-3">
              <h5
                  class="card-subtitle mb-2 text-muted"
                  style="font-size: 1rem"
              >
                  <div class="fieldgroup">
                    <div class="row">
                    <div class="col-md-4">
                      {{ data.id.label }}
                    </div>
                    <div class="col-md-8">
                   <input type='text' class="form-control" value="{{data.id.value}}" name="documentId"  placeholder="{{data.id.placeholder}}">
                  <span class="error hidden">{{data.id.error}}</span>
                  </div>
                </div>
              </div>


              </h5>
          </div>
          <div class="row card-subtitle pl-3 mt-1 pr-3">
              <h4
                  class="card-subtitle mb-2 text-muted"
                  style="font-size: 1rem"
              >
                  <div class="fieldgroup">
                    <div class="row">
                    <div class="col-md-4">
                      {{ data.date.label }}
                    </div>
                    <div class="col-md-8">

                      <div class="input-group">
                        <input
                          class="form-control"
                          placeholder="yyyy-mm-dd"
                          id="contract-date"
                          name="dp"
                          [(ngModel)]="model"
                          ngbDatepicker
                          #d="ngbDatepicker"
                          name="calendardate"
                        />

                        <button class="btn btn-outline-secondary bi bi-calendar3 p-0 m-0" (click)="d.toggle()" type="button">
                          <i class="material-icons align-middle p-0 m-0 calendar-icon">table

                          </i>

                        </button>
                      </div>
       <input
    id="documentCadastre"
        type="file"
        name="documentCadastre"
        #inputFile
        hidden

    />
                  <span class="error hidden">{{data.date.error}}</span>
                  </div>
                </div>
              </div>
              </h4>
          </div>
          <button class="mt-3 btn btn-secondary app-button" (click)="uploadDocument()">
              <span style="font-size: large">
                  {{ data.button }}</span
              >
          </button>
      </div>
  </div>
</div>
-->
